'use client'

import { useState } from 'react'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

interface AccordionItemProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  variant?: 'light' | 'dark'
}

export function AccordionItem({
  title,
  children,
  defaultOpen = false,
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className={cn('border-b', 'border-line')}>
      <button
        className="flex w-full items-center justify-between py-5 text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={cn('text-lg font-medium', 'text-ink')}>
          {title}
        </span>
        <ChevronDown
          className={cn(
            'h-5 w-5 transition-transform duration-200',
            'text-muted',
            isOpen && 'rotate-180'
          )}
        />
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <div className={cn('pb-5', 'text-muted')}>
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

interface AccordionProps {
  children: React.ReactNode
  className?: string
  variant?: 'light' | 'dark'
}

export function Accordion({ children, className }: AccordionProps) {
  return (
    <div className={cn('divide-y divide-line', className)}>
      {children}
    </div>
  )
}
